import { render, staticRenderFns } from "./BannerQuitarAdsVertical.vue?vue&type=template&id=53934dfd&scoped=true"
import script from "./BannerQuitarAdsVertical.vue?vue&type=script&lang=js"
export * from "./BannerQuitarAdsVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53934dfd",
  null
  
)

export default component.exports